export const DEFAULT_PART_QUANTITY = 1
export const MAX_NUMBER_OF_PARTS = 200
export const MAX_ORDER_QUANTITY = 99999
